import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
      }`}
    >
      <div className="flex items-center justify-between h-16 px-4 md:px-6">
        <Link
          to="/"
          className={`flex items-center gap-2 whitespace-nowrap cursor-pointer ${
            isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
          }`}
        >
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-fire-line text-2xl"></i>
          </div>
          <span className="text-lg font-semibold font-heading tracking-wider">黑料网不打烊</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/'
                ? isHome && !scrolled
                  ? 'bg-background-50/20 text-background-50'
                  : 'bg-primary-100 text-primary-700'
                : isHome && !scrolled
                  ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700'
                  : isHome && !scrolled
                    ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              location.pathname === '/about'
                ? 'bg-primary-100 text-primary-700'
                : isHome && !scrolled
                  ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <div className={`w-8 h-8 flex items-center justify-center cursor-pointer ${
            isHome && !scrolled ? 'text-background-50/70 hover:text-background-50' : 'text-foreground-500 hover:text-foreground-700'
          } transition-colors`}>
            <i className="ri-search-line text-lg"></i>
          </div>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
            isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
          }`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
          <div className="flex flex-col gap-2">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-700' : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about' ? 'bg-primary-100 text-primary-700' : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}